import { GRAPHQL_ENDPOINT, SITE } from "@api/constants";

import addAllToCartMutation from "../mutations/add-all-to-cart";

export type CartItemRequest = {
  productId: string;
  quantity: number;
  format: string;
};

const addAllToCart = async (token: string, request: CartItemRequest[]) => {
  const body = {
    query: addAllToCartMutation,
    variables: { request },
  };

  const response = await fetch(GRAPHQL_ENDPOINT, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(body),
  });

  const responseBody = await response.json();
  return responseBody?.data.addAllToCart;
};

export default addAllToCart;
